module.exports = __webpack_public_path__ + "img/zoom_plus.bfeff872.svg";